import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import GroupTab from './GroupTab';
import OperatorTab from './OperatorTab';
import PF2MTabs from '~/components/PF2MTabs';

const OperatorGroup = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Group') },
    { key: 1, label: translate('common:Operator') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <div style={{ height: '100%', overflowY: 'auto', scrollbarWidth: 'none' }}>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<GroupTab />) : null}
      {selectedTab === 1 ? (<OperatorTab />) : null}
    </div>
  );
};

export default withStyles(styles)(OperatorGroup);
